import React from 'react';

const BenefitsSection = () => {
    const benefits = [
        {
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polygon points="23 7 16 12 23 17 23 7"></polygon>
                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                </svg>
            ),
            title: 'Showcase Your Venue',
            description: 'Add videos and photos of your grounds, ranges, pegs, and facilities.'
        },
        {
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
            ),
            title: 'Attract New Visitors',
            description: 'Increase visibility and reach shooters looking for their next venue.'
        },
        {
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
            ),
            title: 'Event Management',
            description: 'Create and promote competitions, shoot days, and open events.'
        },
        {
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 20V10"></path>
                    <path d="M18 20V4"></path>
                    <path d="M6 20v-4"></path>
                </svg>
            ),
            title: 'Performance Analytics',
            description: 'Track scores and provide insights across all shooting disciplines.'
        },
        {
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                </svg>
            ),
            title: 'Premium Profile',
            description: 'Stand out with a verified badge and enhanced listing features.'
        }
    ];

    const venueTypes = [
        {
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="6"></circle>
                    <circle cx="12" cy="12" r="2"></circle>
                </svg>
            ),
            name: 'Clay Grounds',
            description: 'Sporting, Skeet, Trap & ABT clubs'
        },
        {
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 3L2 12h3v8h14v-8h3L12 3z"></path>
                    <path d="M9 21v-6h6v6"></path>
                </svg>
            ),
            name: 'Game Estates',
            description: 'Driven shoots, syndicates & pegs'
        },
        {
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M2 12h6l2-3h4l2 3h6"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                    <path d="M12 9V6"></path>
                    <path d="M12 18v-3"></path>
                    <path d="M9 12H6"></path>
                    <path d="M18 12h-3"></path>
                </svg>
            ),
            name: 'Rifle Ranges',
            description: 'Indoor & outdoor rifle clubs'
        }
    ];

    return (
        <section className="benefits-section">
            <div className="container">
                <div className="benefits-header">
                    <span className="benefits-badge">For Venues</span>
                    <h2 className="benefits-title">
                        List Your Club, Range<br />
                        <span>or Pegs on ShootConnect</span>
                    </h2>
                    <p className="benefits-subtitle">
                        Join our network of shooting venues and reach thousands of passionate shooters. 
                        Whether you run a clay ground, rifle range, or game estate - we've got you covered.
                    </p>
                </div>

                {/* Venue Types */}
                <div className="venue-types">
                    {venueTypes.map((venue, index) => (
                        <div key={index} className="venue-type-card">
                            <div className="venue-type-icon">{venue.icon}</div>
                            <h4>{venue.name}</h4>
                            <p>{venue.description}</p>
                        </div>
                    ))}
                </div>

                <div className="benefits-grid">
                    {benefits.map((benefit, index) => (
                        <div key={index} className="benefit-card">
                            <div className="benefit-icon">
                                {benefit.icon}
                            </div>
                            <h4 className="benefit-title">{benefit.title}</h4>
                            <p className="benefit-description">{benefit.description}</p>
                        </div>
                    ))}
                </div>

                <div className="benefits-cta">
                    <div className="benefits-cta-content">
                        <h3>Want to claim your venue listing?</h3>
                        <p>Create your account first, then request a verified venue claim. Our team validates ownership, completes billing, and assigns your admin access.</p>
                    </div>
                    <a href="/register?intent=venue-claim" className="benefits-cta-btn">
                        Create Account To Claim
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                            <polyline points="12 5 19 12 12 19"></polyline>
                        </svg>
                    </a>
                </div>
            </div>

            <style jsx>{`
                .benefits-section {
                    padding: 120px 0;
                    background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
                }

                .benefits-header {
                    text-align: center;
                    max-width: 640px;
                    margin: 0 auto 60px;
                }

                .benefits-badge {
                    display: inline-block;
                    padding: 8px 16px;
                    background: rgba(76, 175, 80, 0.1);
                    border: 1px solid rgba(76, 175, 80, 0.2);
                    border-radius: 50px;
                    color: #4CAF50;
                    font-size: 13px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    margin-bottom: 20px;
                }

                .benefits-title {
                    font-family: var(--font-heading);
                    font-size: 48px;
                    font-weight: 700;
                    line-height: 1.15;
                    color: #191919;
                    margin-bottom: 20px;
                }

                .benefits-title span {
                    background: linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }

                .benefits-subtitle {
                    font-size: 18px;
                    line-height: 1.7;
                    color: #666;
                }

                /* Venue Types */
                .venue-types {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 24px;
                    margin-bottom: 60px;
                }

                .venue-type-card {
                    background: #ffffff;
                    border: 2px solid #e9ecef;
                    border-radius: 20px;
                    padding: 32px;
                    text-align: center;
                    transition: all 0.3s ease;
                }

                .venue-type-card:hover {
                    border-color: #FF6A00;
                    transform: translateY(-4px);
                    box-shadow: 0 12px 32px rgba(255, 106, 0, 0.12);
                }

                .venue-type-icon {
                    width: 64px;
                    height: 64px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(135deg, rgba(255, 106, 0, 0.1) 0%, rgba(255, 106, 0, 0.15) 100%);
                    border-radius: 16px;
                    margin: 0 auto 20px;
                }

                .venue-type-icon svg {
                    width: 28px;
                    height: 28px;
                    color: #FF6A00;
                }

                .venue-type-card h4 {
                    font-family: var(--font-heading);
                    font-size: 20px;
                    font-weight: 600;
                    color: #191919;
                    margin: 0 0 8px;
                }

                .venue-type-card p {
                    font-size: 14px;
                    color: #666;
                    margin: 0;
                }

                .benefits-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 24px;
                    margin-bottom: 80px;
                }

                .benefit-card {
                    background: #ffffff;
                    border: 1px solid #e9ecef;
                    border-radius: 20px;
                    padding: 36px;
                    transition: all 0.3s ease;
                }

                .benefit-card:hover {
                    border-color: #4CAF50;
                    transform: translateY(-4px);
                    box-shadow: 0 12px 32px rgba(76, 175, 80, 0.12);
                }

                .benefit-icon {
                    width: 56px;
                    height: 56px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(76, 175, 80, 0.15) 100%);
                    border-radius: 14px;
                    margin-bottom: 20px;
                }

                .benefit-icon svg {
                    width: 26px;
                    height: 26px;
                    color: #4CAF50;
                }

                .benefit-title {
                    font-family: var(--font-heading);
                    font-size: 20px;
                    font-weight: 600;
                    color: #191919;
                    margin: 0 0 12px;
                }

                .benefit-description {
                    font-size: 15px;
                    line-height: 1.6;
                    color: #666;
                    margin: 0;
                }

                .benefits-cta {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 40px 48px;
                    background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
                    border-radius: 24px;
                }

                .benefits-cta-content h3 {
                    font-family: var(--font-heading);
                    font-size: 28px;
                    font-weight: 700;
                    color: #ffffff;
                    margin: 0 0 8px;
                }

                .benefits-cta-content p {
                    font-size: 16px;
                    color: rgba(255, 255, 255, 0.7);
                    margin: 0;
                }

                .benefits-cta-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 10px;
                    padding: 16px 32px;
                    background: linear-gradient(135deg, #4CAF50 0%, #43A047 100%);
                    border-radius: 12px;
                    color: #ffffff;
                    font-size: 16px;
                    font-weight: 600;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    white-space: nowrap;
                }

                .benefits-cta-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 24px rgba(76, 175, 80, 0.4);
                }

                .benefits-cta-btn svg {
                    width: 18px;
                    height: 18px;
                }

                @media (max-width: 1024px) {
                    .venue-types {
                        grid-template-columns: repeat(3, 1fr);
                    }

                    .benefits-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }

                @media (max-width: 768px) {
                    .benefits-section {
                        padding: 80px 0;
                    }

                    .benefits-title {
                        font-size: 32px;
                    }

                    .venue-types {
                        grid-template-columns: 1fr;
                    }

                    .benefits-grid {
                        grid-template-columns: 1fr;
                    }

                    .benefits-cta {
                        flex-direction: column;
                        text-align: center;
                        gap: 24px;
                        padding: 32px 24px;
                    }
                }
            `}</style>
        </section>
    );
};

export default BenefitsSection;
